import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

/**
 * Função para buscar uma unidade de revenda.
 * @param {Object} params - Parâmetros para busca da unidade de revenda.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.id - ID da unidade de revenda.
 * @returns {Promise<any>} - Resposta da API.
 */
export const getRevendaUnidade = async ({
  authToken,
  id,
}: {
  authToken: string;
  id: string;
}): Promise<any> => {
  const url = `/api/RevendaUnidade/${id}`;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.get(url, config);
  return response?.data;
};
